import React, { useState } from 'react';
import { mountIsland } from '../mountIsland';
import { lang, __ } from '../Lang.js';

const ChallengesSearchResults = (attributes) => {

  const { query, searchResults } = attributes;

  return (
    <div className="challenges-search-results-container">
      <h3>{ __('Search Results for') + ' "' + query + '"' }</h3>
      {searchResults.map((result) => (
        <div className="card mb-4" key={result.id}>
          <div className="card-body">
            <blockquote className="blockquote mb-0 lh-base">{ result.quote }</blockquote>
            <p className="text-end">
              <cite>-John-Roger</cite>
            </p>
          </div>
          <a href={"/app/challenge/show/" + result.id} className="btn btn-primary">{ __("View") }</a>
        </div>
      ))}
    </div>
  );
}

const challengesSearchContainer = document.getElementById('challenges-search');
if (challengesSearchContainer) {
    const results = challengesSearchContainer.getAttribute('data-results');
    const domSearchResults = JSON.parse(results) ?? [];
    const searchForm = document.getElementById('challenge-search-form');
    searchForm.addEventListener('submit', (event) => {
        event.preventDefault();
        const query = event.target.querySelector('[name="query"]').value;
        axios.get('/api/challenge/search/?query=' + encodeURI(query))
          .then( (response) => {
            console.log(response.data);
            mountIsland(
              challengesSearchContainer,
              <ChallengesSearchResults query={query} searchResults={response.data} />,
            );
          });
    });
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    let query = params.query;

    mountIsland(
        challengesSearchContainer,
        <ChallengesSearchResults query={query} searchResults={domSearchResults} />,
    );
}